<template>
  <div class="group">
      <label for="state">Province</label>
      <select id="state" class="validation selectOptGroupCAState" v-bind:class="{ '-invalid': $parent.validation.state }" v-model="$parent.fields.state" @change="$parent.validation.state = null">
          <option selected disabled value="">Choose one</option>
          <option value="AB">Alberta</option>
        	<option value="BC">British Columbia</option>
        	<option value="MB">Manitoba</option>
        	<option value="NB">New Brunswick</option>
        	<option value="NL">Newfoundland and Labrador</option>
        	<option value="NS">Nova Scotia</option>
        	<option value="ON">Ontario</option>
        	<option value="PE">Prince Edward Island</option>
        	<option value="QC">Quebec</option>
        	<option value="SK">Saskatchewan</option>
        	<option value="NT">Northwest Territories</option>
        	<option value="NU">Nunavut</option>
        	<option value="YT">Yukon</option>
      </select>
      <div class="error-message" v-for="message in $parent.validation.state">{{ message }}</div>
  </div>
</template>

<script>
    import mixin from './mixin';

    export default {
        name: 'state-ca',
        data() {
            return {
                active: false
            }
        },
        mixins: [ mixin ],  
        methods:{
        }
    }
</script>
